import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref } from "vue";
import Dialog from "primevue/dialog";
import mitt from "@/utils/mitt";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseComponent',
  setup(__props) {

mitt.on("openModal", (props: any) => {
  showModal.value = true;
  componentName.value = props.component;
  componentProps.value = props.componentProps;
  width.value = props.width ?? 50;
  maxWidth.value = props.maxWidth ?? "100%";
});
mitt.on("closeModal", () => {
  handleCloseModal();
});

const showModal = ref<boolean>(false);
const componentName = ref<object>();
const componentProps = ref<any>();
const width = ref<number>(50);
const maxWidth = ref<string>("100%");

const handleCloseModal = () => {
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    header: " ",
    visible: showModal.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: _normalizeStyle({ width: `${width.value}vw`, maxWidth: maxWidth.value }),
    modal: true
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(componentName.value), { componentProps: componentProps.value }, null, 8, ["componentProps"]))
    ]),
    _: 1
  }, 8, ["visible", "style"]))
}
}

})